export class Message {
    messageId: number;
    appointmentId: number;
    providerId: number;
    patientId: number;
    messages: string;
    active: boolean;
    doctorMessageCount?: number;
    patientMessageCount?: number;
}